<template>
    <div class="FM_accountList">
        <!-- 平台账户 -->
        <el-card class="box-card">
            <!-- 分润账户 -->
            <el-row>
                <!-- 其他机构 -->
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-card class="cardChild" shadow="hover">
                        <div slot="header">
                            <span style="font-size:13px;font-weight:700">分润账户</span>
                            <el-button v-if="level==1" style="position: relative;right: -260px;width: 23%;height: 28px;line-height: 0;" type="primary" class="button" size="medium" @click="tiXianDialog(0)">提现</el-button>
                        </div>
                        <div class="price">
                            <span>¥{{balancetotal.zero}}</span>
                        </div>
                        <div class="bottom">
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="primary"
                                class="button"
                                size="medium"
                                @click="handleInfoin0()"
                            >分润收入列表[{{balancetotal.balance_zero}}]</el-button>
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="warning"
                                class="button"
                                size="medium"
                                @click="handleInfoout0()"
                            >分润提现列表[{{balancetotal.withdraw_zero}}]</el-button>
                        </div>
						<br>
						<div class="bottom">
						    <el-button style="width: 50%;height: 28px;line-height: 0;"
						        type="danger"
						        class="button"
						        size="medium"
								@click="handleInfopay0()"
						    >分润扣款[{{balancetotal.pay_zero}}]</el-button>
						    <el-button style="width: 50%;height: 28px;line-height: 0;"
						        type="success"
						        class="button"
						        size="medium"
								@click="handleInfopayback0()"
						    >分润回款[{{balancetotal.pay_back_zero}}]</el-button>
						</div>
                    </el-card>
                </el-col>
                <!-- 其他机构信息说明 -->
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-card class="cardChild" shadow="hover" style="height:235px">
                        <div class="rightTitle">
                            <span>分润账户</span>
                        </div>
                        <div class="rightTitle">
                            <!-- <span>用途：</span> -->
                            <span>1、商户交易金额对应的分润账户。</span>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <!-- 活动账户 -->
            <el-row>
               <!-- 其他机构 -->
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-card class="cardChild" shadow="hover">
                        <div slot="header">
                            <span style="font-size:13px;font-weight:700">活动账户</span>
                            <el-button v-if="level==1" style="position: relative;right: -260px;width: 23%;height: 28px;line-height: 0;" type="primary" class="button" size="medium" @click="tiXianDialog(1)">提现</el-button>
                        </div>
                        <div class="price">
                            <span>¥{{balancetotal.one}}</span>
                        </div>
                        <div class="bottom">
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="primary"
                                class="button"
                                size="medium"
                                @click="handleInfoin1()"
                            >活动收入列表[{{balancetotal.balance_one}}]</el-button>
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="warning"
                                class="button"
                                size="medium"
                                @click="handleInfoout1()"
                            >活动提现列表[{{balancetotal.withdraw_one}}]</el-button>
                        </div>
                        <br>
                        <div class="bottom">
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="danger"
                                class="button"
                                size="medium"
								@click="handleInfopay1()"
                            >活动扣款[{{balancetotal.pay_one}}]</el-button>
                            <el-button style="width: 50%;height: 28px;line-height: 0;"
                                type="success"
                                class="button"
                                size="medium"
								@click="handleInfopayback1()"
                            >活动回款[{{balancetotal.pay_back_one}}]</el-button>
                        </div>
                    </el-card>
                </el-col>
                <!-- 其他机构信息说明 -->
                <el-col :xs="24" :sm="24" :md="12" :lg="12" >
                    <el-card class="cardChild" shadow="hover" style="height:235px">
                        <div class="rightTitle">
                            <span>活动账户</span>
                        </div>
                        <div class="rightTitle">
                            <span>1、激活达标奖励、交易量达标奖励、交易量阶梯达标奖励、流量卡扣费返现、政策加码奖励等市场营销活动账户。</span>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-divider></el-divider>
			<!-- 活动账户 -->
			<el-row>
			   <!-- 其他机构 -->
			    <el-col :xs="24" :sm="24" :md="12" :lg="12">
			        <el-card class="cardChild" shadow="hover">
			            <div slot="header">
			                <span style="font-size:13px;font-weight:700">押金账户</span>
			                <el-button v-if="level==1" style="position: relative;right: -260px;width: 23%;height: 28px;line-height: 0;" type="primary" class="button" size="medium" @click="tiXianDialog(2)">提现</el-button>
			            </div>
			            <div class="price">
			                <span>¥{{balancetotal.two}}</span>
			            </div>
			            <div class="bottom">
			                <el-button style="width: 50%;height: 28px;line-height: 0;"
			                    type="primary"
			                    class="button"
			                    size="medium"
			                    @click="handleInfoin2()"
			                >押金收入列表[{{balancetotal.balance_two}}]</el-button>
			                <el-button style="width: 50%;height: 28px;line-height: 0;"
			                    type="warning"
			                    class="button"
			                    size="medium"
			                    @click="handleInfoout2()"
			                >押金提现列表[{{balancetotal.withdraw_two}}]</el-button>
			            </div>
						<br>
						<div class="bottom">
						    <el-button style="width: 50%;height: 28px;line-height: 0;"
						        type="danger"
						        class="button"
						        size="medium"
								@click="handleInfopay2()"
						    >押金扣款[{{balancetotal.pay_two}}]</el-button>
						    <el-button style="width: 50%;height: 28px;line-height: 0;"
						        type="success"
						        class="button"
						        size="medium"
								@click="handleInfopayback2()"
						    >押金回款[{{balancetotal.pay_back_two}}]</el-button>
						</div>
			        </el-card>
			    </el-col>
			    <!-- 其他机构信息说明 -->
			    <el-col :xs="24" :sm="24" :md="12" :lg="12" >
			        <el-card class="cardChild" shadow="hover" style="height:235px">
			            <div class="rightTitle">
			                <span>押金账户</span>
			            </div>
			            <div class="rightTitle">
			                <span>1、机具押金返现。</span>
			            </div>
			        </el-card>
			    </el-col>
			</el-row>
        </el-card>
        <ti-xian v-if="tiXianIsShow" :tiXianIsShow="tiXianIsShow" :tiXiantype="tiXiantype" @tiXianClose="tiXianClose"></ti-xian>
    </div>
    
</template>

<script>
import tiXian from './FM_tiXian';
export default {
    name: "FM_accountList",
    data() {
        return {
			balancetotal: {},//账户余额
            level: sessionStorage.getItem('level'), //等级
            tiXianIsShow: false, //提现
            tiXiantype: 0, //提现
        }
    },
    components: {
        tiXian,
    },
    mounted() {
        this.getagentBalance();
    },
    methods: {
		getagentBalance() { //获取余额
		    this.$api.post('organization/agent_balance', {}, res => {
		        if (res.code == 0) {
		            this.balancetotal = res.data;
		        } else { 
		            this.$message.error(res.msg);
		        }
		    });
		},
		handleInfoin0() { //分润收入
		    this.$router.push({ path: '/agentaccountList', query: {type:1}});
		},
		handleInfoin1() { //基本账户收入
		    this.$router.push({ path: '/agentaccountList', query: {type:2}});
		},
		handleInfoin2() { //押金账户收入
		    this.$router.push({ path: '/agentaccountList', query: {type:3}});
		},
		
		handleInfoout0() { //分润账户提现
		    this.$router.push({ path: '/agentaccountList', query: {type:4}});
		},
		handleInfoout1() { //基本账户提现
		    this.$router.push({ path: '/agentaccountList', query: {type:5}});
		},
		handleInfoout2() { //押金账户提现
		    this.$router.push({ path: '/agentaccountList', query: {type:6}});
		},
		
		handleInfopay0() { //分润账户扣款
		    this.$router.push({ path: '/agentaccountList', query: {type:7}});
		},
		handleInfopay1() { //基本账户扣款
		    this.$router.push({ path: '/agentaccountList', query: {type:8}});
		},
		handleInfopay2() { //押金账户扣款
		    this.$router.push({ path: '/agentaccountList', query: {type:9}});
		},
		
		handleInfopayback0() { //分润账户回款
		    this.$router.push({ path: '/agentaccountList', query: {type:10}});
		},
		handleInfopayback1() { //活动账户回款
		    this.$router.push({ path: '/agentaccountList', query: {type:11}});
		},
		handleInfopayback2() { //押金账户回款
		    this.$router.push({ path: '/agentaccountList', query: {type:12}});
		},
		tiXianDialog(type) { //提现弹窗
		    this.tiXianIsShow = true;
		    this.tiXiantype=type;
		},
		tiXianClose() { //关闭提现弹窗
		    this.tiXianIsShow = false;
		    this.getagentBalance();//刷新
		},
		
		
		
		
        // handleDownLoad() { //导出
        //     this.downLoading = true;
        //     this.$api.post("user/agent_activity_profit_download",[], res => {
        //         if (res.code == 0) {
        //             this.$message.success(res.msg);
        //             var link=this.$file_url+res.data;
        //             window.open(link)
        //         } else {
        //             this.$message.error(res.msg);
        //         }
        //         //渲染结束后取消加载
        //         this.downLoading = false;
        //     })
        // },
    }
};
</script>

<style lang="scss" scope>
.FM_accountList {
    font-size: 12px;
    .price {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .el-col {
        margin: 10px 0;
    }
    .rightTitle {
        margin: 20px;
        :nth-child(1) {
            font-weight: 700;
        }
    }
    .cardChild {
        min-width: 350px;
        max-width: 450px;
    }
    .bottom {
        .el-button {
            font-size: 12px;
        }
        display: flex;
        justify-content: flex-end;
    }
    // .el-dialog {
    //     display: flex;
    //     flex-direction: column;
    //     margin: 0 !important;
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     /*height:600px;*/
    //     max-height: calc(100% - 30px);
    //     max-width: calc(100% - 30px);
    // }
    // .el-dialog .el-dialog__body {
    //     flex: 1;
    //     overflow: auto;
    // }
}
.FM_accountList .price {
    height: 70px;
}
</style>
